<template>
    <section class="home">
        <h1>Bienvenue sur Isidoor v2</h1>
        <div class="text-content">
            <p>Isidoor v2 est un outil regroupant différentes astuces de programmation web, bonnes pratiques et outils de génération de code.</p>
        </div>
    </section>
</template>
